import Big from 'big.js';

/**
 * Formatea un importe para mostrar: "$ 1.234,56", o "—" si no hay valor.
 * El formato de importes sigue abierto en el design system (§6.5): si cambia, se cambia acá.
 */
export function formatMoney(amount: number | Big | null | undefined): string {
    if (amount === null || amount === undefined) return '—';
    const value = amount instanceof Big ? amount.toNumber() : amount;
    return `$ ${value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Suma importes con precisión decimal (nunca con `number`). Los vacíos cuentan como 0. */
export function sumMoney(amounts: Array<number | null | undefined>): Big {
    return amounts.reduce<Big>((total, amount) => total.plus(amount ?? 0), new Big(0));
}
